import React, { Suspense } from "react";
import { parseStyle, mobile, tablet, decodeStyle } from "../../../../juntion";
import FallbackLoader from "../special/FallbackLoader";
// import QSwiper from "./qswiper/QSwiper";
import log from "cslog";
// import { parseImageArray } from "../../../../../dynamicdata/parser";
import { parseImageArray } from "../../../../junctionAbs";

const QSwiper = React.lazy(() => import("./qswiper/QSwiper"));

function ImageCarousel({ id, db, dydb, device, gs }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    const tabletStyle = tablet(device) ? ps.tablet : {};
    const mobileStyle = mobile(device) ? ps.mobile : {};

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    // const photos =
    //     input.photos.length > 0 ? input.photos : [{ full: "/img_pp.png" }];
    const photos = parseImageArray(dydb, input.photos);

    const styleImg = decodeStyle(ps.styleGroup.image, gs);

    // log.d(input, "ImageCarousel Input");

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Suspense
                fallback={
                    <FallbackLoader
                        height={input.sliderSize.params}
                        text="Loaing slider..."
                    />
                }
            >
                <QSwiper input={input} photos={photos} styleImg={styleImg} />
            </Suspense>
        </div>
    );
}

export default ImageCarousel;
